import React from 'react';

export default function FormasPagamento() {


  return (
    <div className='container-box'>
      <h5>Formas de pagamento</h5>
      <span className='title-describe'>Cadastre seu cartão de crédito para pagar automaticamente.</span>
      <hr />
      <div className="row text-center">

      </div>
    </div>
  )
}